import styled from '@emotion/styled'
import { Box, Grid } from '@mui/material'
import { AuthLayout, MButton, SvgImage, Text } from 'components'
import { ROUTES_PATH, WELCOME_DESCRIPTION, WELCOME_TITLE } from 'config'
import { color } from 'config/color'
import { Navigate, useLocation, useNavigate } from 'react-router-dom'
import { AuthMain, AuthWrapper } from '../SignIn'

export const SignupSuccess: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()


  const handleBack = (): void => {
    navigate(ROUTES_PATH.SIGNIN)
  }

  const IconComponent = styled(Box)`
    align-content: center;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
  `
  if (location.key === 'default') {
    return <Navigate to={ROUTES_PATH.SIGNIN} state={{ from: location }} replace />
  }

  return (
    <AuthLayout
      title={WELCOME_TITLE}
      desc={WELCOME_DESCRIPTION}
      isAuthPage={true}
    >
      <AuthWrapper isAuthPage={true}>
        <Grid container justifyContent='center'>
          <Grid item xs={12} md={6}>
            <AuthMain isRounded={true}>
              <IconComponent>
                <SvgImage name="GreenCheckIcon" width={250} height={62} />
                <Text
                  heading="h2"
                  color={color.grey[900]}
                  fontSize="24px"
                  align="center"
                  margin="16px 0 30px"
                  fontWeight="600"
                >
                  You have been registered
                </Text>
              </IconComponent>
              <Text fontSize="16px" color={color.grey[700]} margin="0 0 20px">
                You have successfully registered your account at NEP Portal.{' '}
              </Text>
              <Text fontSize="16px" color={color.grey[700]} margin="10 0 20px">
                If you did not receive the email, please call NEP Customer
                Service at{' '}
                <a href="tel:877-818-2637" color={color.background[900]} >
                  877-818-2637
                </a>
              </Text>

              <Box mt={3} mb={1} display="flex" justifyContent="center">
                <MButton
                  type="button"
                  variant="contained"
                  size="large"
                  rounded="true"
                  sx={{ width: '200px', marginTop: '32px' }}
                  onClick={handleBack}
                >
                  Back to log in
                </MButton>
              </Box>
            </AuthMain>
          </Grid>
        </Grid>
      </AuthWrapper>
    </AuthLayout >
  )
}
